import React from 'react';
import GTMScript from 'components/GTMScript';
import CoachingSelfServeView from 'coaching/components/CoachingSelfServeView/CoachingSelfServeView';
import CoachingStripeContainer from './components/CoachingStripeContainer';

export default function CoachingSelfServeContainer() {
  return (
    <React.Fragment>
      <GTMScript />
      <CoachingStripeContainer>
        <CoachingSelfServeView />
      </CoachingStripeContainer>
    </React.Fragment>
  );
}
